import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
export function Product() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-beige py-20 px-6" data-id="element-197">
      <div className="max-w-5xl mx-auto" data-id="element-198">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-199">
          <div className="flex-1 w-full" data-id="element-200">
            <FadeIn data-id="element-201">
              <div className="relative max-w-md mx-auto" data-id="element-202">
                <img src="https://cdn.magicpatterns.com/uploads/fRqZGDUfzvBvZ3MhZduMEC/portada_como_vender_en_amazon_comprimida_.png" alt="Cómo Vender en Amazon FBA Desde Cero (2026) - Guía Completa" className="w-full h-auto rounded-2xl shadow-2xl object-contain" data-id="element-203" />
              </div>
            </FadeIn>
          </div>

          <div className="flex-1 text-center md:text-left" data-id="element-204">
            <FadeIn delay={0.2} data-id="element-205">
              <h2 className="text-3xl md:text-4xl font-bold text-brand-green mb-6 leading-tight" data-id="element-206">
                Cómo vender en Amazon FBA desde cero (2026)
              </h2>
              <p className="text-lg text-brand-text mb-6" data-id="element-207">
                Una guía práctica, clara y estructurada para ayudarte a entender
                y ejecutar todo el proceso.
              </p>
              <p className="text-lg text-brand-text font-medium mb-10 pb-6 border-b border-brand-green/10" data-id="element-208">
                Diseñada para personas que están empezando.
              </p>
              <Button onClick={scrollToPricing} className="w-full sm:w-auto" data-id="element-209">
                QUIERO ACCEDER A LA GUÍA
              </Button>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}